import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import DatabaseImportIcon from 'mdi-react/DatabaseImportIcon';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess } from "../../Services/SecurityService";
import { check, findAllRequerimento } from "../../Services/RequerimentoService";
import { findAllEstado } from "../../Services/EstadoService";
import { findAllCidade } from "../../Services/CidadeService";

import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);

    this.state = {
      hasAccess: false,
      
      selected: {},
      estados: {},
      cidades: [],
      data: []
    };
    check();
  }

  loadRequerimento(process){
    findAllRequerimento()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ data: data, process});
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadCidades(){
    findAllCidade()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadEstado(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(cidadeList){
    findAllEstado()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      let cidades = [];
      let estados = [];
      if(data !== undefined && data.error === undefined){
        let estadosMap = new Map();
        estados = data;
        for(let i = 0; i < estados.length; i++){
          cidades = [];
          for(let j = 0; j < cidadeList.length; j++){
            if(estados[i].id === cidadeList[j].estado.id){
              cidades.push(cidadeList[j]);
            }
          }
          estados[i].cidades = cidades;
          estadosMap.set(estados[i].uf.toLowerCase(), estados[i]);
        }
        this.setState({ estados: estadosMap, cidades: cidadeList });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_REQUIREMENT_SYNC_CITY_PROCCESS")){
      // this.loadRequerimento(false);
      this.loadCidades();
      this.setState({ hasAccess: true });
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  processar = () => {
    this.setState({ process: true });
  }

  updateTable = (process) => {
    this.loadRequerimento(process);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = this.state.process;
    let notOK = !hasAccess("MENU_REQUIREMENT_SYNC_CITY_PROCCESS");


    if(this.state.hasAccess){
      if(this.state.process){
        view =  <CrudEdit 
                  list={this.state.data}
                  estados = {this.state.estados}
                  cidades = {this.state.cidades}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.requerimentoSync_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.requerimentoSync_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.processar()}>
                <DatabaseImportIcon /> {t('forms.processar')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);